import { usePrevRoute } from "hooks/usePrevRoute";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { actions as environmentActions } from "reducers/environment";

export const useHistoricData = (hasBackupData) => {
    const dispatch = useDispatch();
    const { prevPath = "" } = usePrevRoute();
    const { pathname } = useLocation();

    const getBackupDataByStepId = (idStep) => {
        dispatch(environmentActions.getStepData(idStep));
    };

    // To get data when page was reload
    const getBackupDataByPath = () => {
        const path = pathname.split("/");
        const idStep = path[path.length - 1];
        if (!hasBackupData) {
            dispatch(environmentActions.getStepData(idStep));
        }
    };

    useEffect(() => {
        if (!prevPath || prevPath === "/desktop") {
            getBackupDataByPath();
        }
    }, []);

    return { getBackupDataByStepId };
};

export default useHistoricData;
